import { vfFavourite } from "./Clients/vodafone/Models/SchemaModels";

export const SchemaModel: Record<string, any> = {
  vodafone: {
    favourite: vfFavourite
  }
};
